module.exports = __webpack_public_path__ + "img/login_4.396dbfc8.png";